export default __webpack_public_path__ + "static/media/NAREVA.cc5088ed.jpg";